module.exports = __webpack_public_path__ + "static/media/image_68.5e2648bb.png";